import { type FC } from "react";
import { Navigate, Outlet, generatePath, useLocation, useMatch } from "react-router-dom";
import { AbsoluteRoute } from "../../../core/routes";
import { useOrganizationSwitcher } from "../../organizations/hooks/useOrganizationSwitcher";
import { CardWithBannerSkeletonContainer } from "../components/CardWithBannerSkeletonContainer";

export const OrganizationContainer: FC = () => {
    //  TODO: unify selected organization logic, reduce duplicated state
    const { pathname } = useLocation();
    const match = useMatch({ path: AbsoluteRoute.ORG_LENS_SCHEDULER, end: false });
    const paramOrgID = match?.params?.orgId;
    const { selectedOrganizationId } = useOrganizationSwitcher(paramOrgID);

    return (
        <CardWithBannerSkeletonContainer loading={selectedOrganizationId == null}>
            {pathname === match?.pathname && selectedOrganizationId && paramOrgID && (
                <Navigate to={generatePath(AbsoluteRoute.ORG_LENS_SCHEDULER_GROUPS, { orgId: paramOrgID })} />
            )}
            <Outlet />
        </CardWithBannerSkeletonContainer>
    );
};
